/**********************************************************************************************************************/
/* FILE: hafas_webapp_app.js                                                                                          */
/**********************************************************************************************************************/
// contstructor for webapp, declare global Hafas-Variables
var HafasWebview = function () {
  // Subscriptions für Webview initialisieren
  this.subscriptions.webviews(this);
  Hafas.bind(this.Controller.Webviews.init, this)(Hafas.Config.webview);
};

var HafasPolicy = function (params) {
  this.policy = {};
  if (typeof this.subscriptions.policy != 'undefined') {
    this.subscriptions.policy(this);
  }
  Hafas.getWebAppContext = function () {
    return 'policy';
  };
  this.Controller.Policy.init(params);
};

var HafasWebapp = function (params) {

  var _me = this;

  // Werte den subPath aus und setze entsprechende WhiteLabel-Flags
  if (typeof subPath != 'undefined' && subPath != '') {
    Hafas.Config.whiteLabel.isWhitelabel = true;
    Hafas.Config.whiteLabel.imgPath = 'customer/' + subPath + Hafas.Config.imagePath;


  }

  var model = {
    webappWrap: "HFS_WebApp",
    contentContainer: 'HFS_PageContent',
    pageHeader: 'HFS_PageHeader',
    pageFooter: 'HFS_PageFooter',
    forceLayoutClass: Hafas.Config.forceLayoutClass,
    layoutClass: Hafas.Config.layoutClass,
    layoutMode: Hafas.Config.layoutMode,
    formContainer: 'HFS_DocumentFormWrapper',
    formUIHiddenActions: null,
    resultOverviewContainer: 'HFS_DocumentResultOverview',
    resultDetailContainer: 'HFS_DocumentDetailOverview',
    additionalContainer: 'HFS_DocumentAdditionalContainer',
    mapContainer: 'HFS_PageMap',
    mapHeaderContainer: 'HFS_PageMapHeader',
    mapSideDrawer: 'HFS_PageSideDrawer',
    mapSideDrawerTrigger: 'HFS_PageSideDrawerTrigger',
    templateBasePath: Hafas.Config.scriptTemplateLayoutPath,
    appContext: Hafas.Config.startingAppContext,
    mapId: 'hfsWebappMap'
  };

  if (params.hasOwnProperty('options')) {
    model.options = params.options;
  }

  this.init(model);

  Hafas.getWebAppContext = function () {
    return _me.appContext + '';
    // neue Stringinstanz. Manipulation über DevTools-Consolen sind jetzt
    // nicht mehr möglich
  };

};

// init methods
HafasWebapp.prototype.init = function (options) {
  // now we can use "this" for applicationwide properties and methods

  // store target container in this (id is stored not the element!)
  this.webappWrap = options.webappWrap;
  this.content = options.contentContainer;
  this.pageHeader = options.pageHeader;
  this.showPageHeader = Hafas.Config.showPageHeader;
  this.pageFooter = options.pageFooter;
  this.layoutClass = options.layoutClass;
  this.forceLayoutClass = options.forceLayoutClass;
  this.formContainer = options.formContainer;
  this.formUIHiddenActions = options.formUIHiddenActions;
  this.resultOverviewContainer = options.resultOverviewContainer;
  this.resultDetailContainer = options.resultDetailContainer;
  this.additionalContainer = options.additionalContainer;
  this.mapContainer = options.mapContainer;
  this.mapHeaderContainer = options.mapHeaderContainer;
  this.mapSideDrawer = options.mapSideDrawer;
  this.mapSideDrawerTrigger = options.mapSideDrawerTrigger;
  this.mapId = options.mapId;
  this.mediaQueries = options.mediaQueries;
  this.mq = null; // -> initial value before resize-event fires, resize returns xs, sm, md, lg, xlg

  if (options.hasOwnProperty('options')) {
    this.options = options.options;

  }
  // den vorhergegangenen appContext behalten.
  // wird in switchAppContext gesetzt
  this.prevContext = null;
  // important global var -> appContext
  this.appContext = options.appContext;

  // additional Containers like Trainroute have to hold a different context cause the additional containers are
  // are called from every appcontext
  this.additionalContext = null;

  this.templateBasePath = options.templateBasePath;

  // render credentials
  this.preloadTemplates(Hafas.bind(this.initController, this));
};

HafasWebapp.prototype.initController = function () {


  Hafas.Core.newType("hafasAtoms", {
    Controller: this.Controller
  });

  // render Base HTML
  this.renderInitialElements();

  // register Events
  this.registerEvents();

  // subscriptions for Event-Loop
  if (typeof this.subscriptions.custom != 'undefined') {
    this.subscriptions.custom(this);
  }
  if (typeof this.subscriptions.livemap != 'undefined') {
    this.subscriptions.livemap(this);
  }
  if (typeof this.subscriptions.map != 'undefined' && Hafas.Config.Switches.useMap == true) {
    this.subscriptions.map(this);
  }
  if (typeof this.subscriptions.Reachability != 'undefined') {
    this.subscriptions.Reachability(this);
  }
  if (((typeof Hafas.Config.SQ.useInToolbox && Hafas.Config.SQ.useInToolbox == true) || Hafas.Config.Switches.useStationboard == true) && typeof this.subscriptions.sq != 'undefined') {
    this.subscriptions.sq(this);
  }
  if (Hafas.Config.Switches.useTravelplanner == true && typeof this.subscriptions.tp != 'undefined') {
    this.subscriptions.tp(this);
  }
  if (typeof this.subscriptions.tq != 'undefined') {
    this.subscriptions.tq(this);
  }
  if (typeof this.subscriptions.app != 'undefined') {
    this.subscriptions.app(this);
  }
  if (typeof this.subscriptions.common != 'undefined') {
    this.subscriptions.common(this);
  }
  if (typeof this.subscriptions.options != 'undefined') {
    this.subscriptions.options(this);
  }
  if (typeof this.subscriptions.apis != 'undefined') {
    this.subscriptions.apis(this);
  }
  if (Hafas.Config.showExceptions == true && typeof this.subscriptions.exceptions != 'undefined') {
    this.subscriptions.exceptions(this);
  }
  if (typeof this.subscriptions.suggest != 'undefined') {
    this.subscriptions.suggest(this);
  }
  if (typeof this.subscriptions.forms != 'undefined') {
    this.subscriptions.forms(this);
  }
  if (typeof this.subscriptions.Inputgen != 'undefined') {
    this.subscriptions.Inputgen(this);
  }
  if (typeof this.subscriptions.Push != 'undefined') {
    this.subscriptions.Push(this);
  }
  if (typeof this.subscriptions.JourneyCourse != 'undefined') {
    this.subscriptions.JourneyCourse(this);
  }
  if (typeof this.subscriptions.LineSearch != 'undefined') {
    this.subscriptions.LineSearch(this);
  }
  if (typeof this.subscriptions.HimSearch != 'undefined') {
    this.subscriptions.HimSearch(this);
  }
  if (typeof this.subscriptions.EventSearch != 'undefined') {
    this.subscriptions.EventSearch(this);
  }
  if (typeof this.subscriptions.TariffSearch != 'undefined') {
    this.subscriptions.TariffSearch(this);
  }

  if (typeof this.subscriptions.ExternalData != 'undefined') {
    this.subscriptions.ExternalData(this);
  }

  if (Hafas.Config.Switches.useFavorites) {
    if (typeof this.subscriptions.favorites != 'undefined') {
      this.subscriptions.favorites(this);
    }
  }

  if (Hafas.Config.Switches.useTimetable) {
    if (typeof this.subscriptions.Timetable(this) != 'undefined') {
      this.subscriptions.Timetable(this);
    }
  }

  if (Hafas.Config.initAnalysisMode) {
    if (typeof this.subscriptions.analysis(this) != 'undefined') {
      this.subscriptions.analysis(this);
    }
  }

  // subscriptions for UI/UX depends on layoutMode (fullmap | classic)
  if (typeof this.subscriptions.GUI != 'undefined') {
    this.subscriptions.GUI(this);
  }

  // subscriptions for PRINT depends on layoutMode (fullmap | classic)
  if (typeof this.subscriptions.PRINT != 'undefined') {
    this.subscriptions.PRINT(this);
  }

  if (typeof this.subscriptions.Imprint != 'undefined') {
    this.subscriptions.Imprint(this);
  }

  this.Controller.Favorites.main = this;

  var _application = '';
  if (typeof Hafas.Config.CustomerObj != 'undefined' && Hafas.Config.CustomerObj !== null) {
    _application = Hafas.Config.storageId + '_' + Hafas.Config.CustomerObj.name
  } else {
    _application = Hafas.Config.storageId;
  }

  this.Controller.Favorites.instance = Hafas.Core.newType("hafasFavorites", {
    maxLocations: Hafas.Config.Favorites.maxLocations,
    maxLocationsHistory: Hafas.Config.Favorites.maxLocationsHistory,
    maxConnections: Hafas.Config.Favorites.maxConnections,
    maxConnectionsHistory: Hafas.Config.Favorites.maxConnectionsHistory,
    maxLines: Hafas.Config.Favorites.maxLines,
    maxLinesHistory: Hafas.Config.Favorites.maxLinesHistory,
    application: _application
  });

  /* Produktvorauswahl aus Config */
  var prodClassTP = 0;
  for (var p = 0; p < Hafas.Config.productClasses.length; p++) {
    if (Hafas.Config.productClasses[p].value) {
      prodClassTP += Hafas.Config.productClasses[p].bit;
    }
  }

  if (Hafas.Config.Switches.useTravelplanner) {
    this.Controller.TP.main = this;
    this.Controller.TP.instance = Hafas.Core.newType("hafasTP", {
      id: 'webapp',
      outDate: Hafas.Config.serverDate,
      outTime: Hafas.Config.serverTime,
      retDate: Hafas.Config.serverDate,
      retTime: Hafas.Config.serverTime,
      useGrouping: Hafas.Config.TP.useGrouping,
      cls: prodClassTP,
      cluster: Hafas.Core.clone(Hafas.Config.TP.cluster)
    });
    if (Hafas.Config.TP.useQueryOptions) {
      var tpOptionModel = {
        application: 'TP',
        model: this.options['TP'],
        instance: this.Controller.TP.instance
      };
      //Optionen zur manuellen Einstellung der IV-Distanzen herausnehmen, wenn Multimodal eingeschaltet ist
      if (Hafas.Config.TP.useGrouping) {
        tpOptionModel.modL = [
          // bei aktivierten Clustern sollen keine IV-Distanzen einstellbar sein, weil diese zur falschen Anzeige von Clustern führen
          {
            for: 'hciType',
            parameter: 'gisProfile',
            change: {key: 'ctxFilter', value: '{"TP": "HIDDEN"}'}
          },
          // wenn es wg. der Cluster keine IV-Distanzeinstellungen gibt, ist die Option "Geschwindigkeit" nicht ausgegraut
          {
            for: 'meta',
            parameter: 'speed',
            change: {key: 'state', value: ''}
          }
        ];
      }
      this.Controller.TP.options = Hafas.Core.newType("HafasOptions", tpOptionModel);
    }
  }


  // Stationboard
  if (Hafas.Config.Switches.useStationboard == true) {
    var sortType = 'line';
    if (typeof Hafas.Config.SQ != 'undefined' && typeof Hafas.Config.SQ.sortType != 'undefined') {
      sortType = Hafas.Config.SQ.sortType;
    }
    var timeMode = 'time';
    if (typeof Hafas.Config.SQ != 'undefined' && typeof Hafas.Config.SQ.timeInfoMode != 'undefined') {
      timeMode = Hafas.Config.SQ.timeInfoMode;
    }
    var autorefresh = false;
    if (typeof Hafas.Config.SQ != 'undefined' && typeof Hafas.Config.SQ.autorefresh != 'undefined') {
      autorefresh = Hafas.Config.SQ.autorefresh;
    }
    var sqRequestSort = 'PT';
    if (typeof Hafas.Config.SQ != 'undefined' && typeof Hafas.Config.SQ.sort != 'undefined') {
      sqRequestSort = Hafas.Config.SQ.sort;
    }
    this.Controller.SQ.main = this;
    var prodClassSQ = 0;
    for (var p = 0; p < Hafas.Config.productClasses.length; p++) {
      prodClassSQ += Hafas.Config.productClasses[p].bit;
    }
    var stopFilter = Hafas.Core.clone(Hafas.Config.SQ.stopFilter);
    stopFilter.forEach(function (item) {
      item.product = Hafas.Util.products.getProductConfigForClass(item.bit);
    });
    this.Controller.SQ.fltrL = stopFilter;

    this.Controller.SQ.instance = Hafas.Core.newType("hafasStboard", {
      id: 'webapp',
      date: Hafas.Config.serverDate,
      time: Hafas.Config.serverTime,
      prodclasses: prodClassSQ,
      showJourneys: 40,
      sortType: sortType,
      timeInfoMode: timeMode,
      autorefresh: autorefresh,
      sort: sqRequestSort,
      fltrL: Hafas.Core.clone(stopFilter)
    });
    if (Hafas.Config.SQ.useQueryOptions) {
      this.Controller.SQ.options = Hafas.Core.newType("HafasOptions", {
        application: 'SQ',
        model: this.options['SQ'],
        instance: this.Controller.SQ.instance
      });
    }
  }

  // Tarifauskunft
  if (Hafas.Config.Switches.useTariffSearch) {
    this.Controller.TariffSearch.main = this;
    this.Controller.TariffSearch.instance = Hafas.Core.newType("hafasTariffSearch", {
      id: 'webapp',
      outDate: Hafas.Config.serverDate,
      outTime: Hafas.Config.serverTime,
      trfCtx: unescape(Hafas.Config.TariffSearch.trfCtx)
    });
  }



  if (Hafas.Config.Switches.useLineSearch == true) {
    this.Controller.LineSearch.main = this;
    this.Controller.LineSearch.instance = Hafas.Core.newType("hafasLineSearch", {
      date: Hafas.Config.serverDate,
      time: Hafas.Config.serverTime
    });

    var lineFilter = Hafas.Core.clone(Hafas.Config.LineSearch.lineFilter);
    lineFilter.forEach(function (item) {
      item.product = Hafas.Util.products.getProductConfigForClass(item.bit);
    });

    this.Controller.LineSearch.lineFilter = lineFilter;
  }

  if (Hafas.Config.Switches.useTimetable == true) {
    this.Controller.Timetable.main = this;
    this.Controller.Timetable.instance = Hafas.Core.newType("hafasTimetable", {});
    this.Controller.Timetable.linesearch = Hafas.Core.newType("hafasLineSearch", {
      date: Hafas.Config.serverDate,
      time: Hafas.Config.serverTime
    });
  }

  if (Hafas.Config.initAnalysisMode == true) {
    this.Controller.Analysis.main = this;
    this.Controller.Analysis.instance = Hafas.Core.newType("hafasAnalysis", {});
  }

  // Maps
  if (Hafas.Modules.Maps && this.Controller.Map && this.mapId !== null && Hafas.Config.Switches.useMap == true) {
    this.Controller.Map.main = this;
    //this.Controller.Map.instance = Hafas.Modules.Maps.getMapById(this.mapId);
    var initCoord = Hafas.Core.newType("hafasCCoord", {
      lon: Hafas.Config.Maps.predefinedArea.lon,
      lat: Hafas.Config.Maps.predefinedArea.lat
    });
    var mapConfigParams = {
      coord: initCoord,
      zoom: Hafas.Config.Maps.predefinedZoom,
      reverseLookup: true,
      layer: [{
        "name": "HAFAS BaseLayer",
        "id": "HafasBaseMap",
        "type": "static",
        "url": Hafas.Config.staticTileURL,
        "attribution": "&copy; OpenStreetMap contributors",
        "isBaseLayer": true
      }],
      baseLayer: Hafas.Config.Maps.baseLayer
    };
    if (typeof Hafas.Config.Maps.controls != 'undefined') {
      mapConfigParams.controls = Hafas.Config.Maps.controls;
    }

    mapConfigParams.useContextmenu = Hafas.Config.Maps.useContextmenu;

    Hafas.ps.sub("/map/show/hfsWebappMap", Hafas.bind(function (mapInstance) {
      this.Controller.Map.mobilityRadar = Hafas.Core.newType("hafasMobilityRadar", {
        map: mapInstance,
        id: 'webapp',
        showstops: true
      });

      // Tracking
      Hafas.ps.pub('/tracking/screen/mobility-map-main', [{typ: 'screen', key: 'mobility-map-main'}]);
    }, this));

    // Initiale Berechnung des Map Containers, sonst hat die Karte bei der Initialisierung Höhe 0
    Hafas('#' + this.mapContainer, false).style.height = window.innerHeight + "px";

    var map = Hafas.Core.newType("hafasMap" + Hafas.Config.Maps.mapApi, 'hfsWebappMap', mapConfigParams);

    //map.show();
    this.Controller.Map.instance = map;

    if (Hafas.Config.Switches.useLivemap) {
      this.Controller.Livemap.main = this;
      Hafas.bind(this.Controller.Livemap.index, this)();
      if (Hafas.Config.Livemap.autostart) {
        this.Controller.Livemap.startLivemap();
      }
    }
    if (this.Controller.CustomToolbox)
      this.Controller.CustomToolbox.index();
    if (this.Controller.ExternalData)
      this.Controller.ExternalData.index(this);
  }

  // Proximity search
  if (Hafas.Config.Switches.useReachability == true) {
    this.Controller.Reachability.main = this;
    this.Controller.Reachability.instance = Hafas.Core.newType("hafasReachability", {
      id: 'webapp',
      map: this.Controller.Map.instance,
      input: 'ReachabilityLocation',
      traveltime: Hafas.Config.Reachability.initialDuration,
      period: Hafas.Config.Reachability.period
    });
    if (Hafas.Config.Reachability.useQueryOptions) {
      this.Controller.Reachability.options = Hafas.Core.newType("HafasOptions", {
        application: 'Reachability',
        model: this.options['Reachability'],
        instance: this.Controller.Reachability.instance
      });
    }
  }


  if (Hafas.Config.Switches.usePush) {
    this.Controller.Push.init();
  }

  // Stoerungskarte HimSearch
  if (Hafas.Config.Switches.useHimSearch) {
    this.Controller.HimSearch.instance = Hafas.Core.newType("hafasHimSearch", {
      map: this.Controller.Map.instance,
      useMap: Hafas.Config.Switches.useMap,
      hideMessagesWithoutGeoInformation: Hafas.Config.HimSearch.hideMessagesWithoutGeoInformation
    });
    if (Hafas.Config.HimSearch.useQueryOptions) {
      this.Controller.HimSearch.options = Hafas.Core.newType("HafasOptions", {
        application: 'HimSearch',
        model: this.options['HimSearch'],
        instance: this.Controller.HimSearch.instance
      });
    }
  }

  // Eventliste/-suche
  if (Hafas.Config.Switches.useEventSearch) {
    this.Controller.EventSearch.instance = Hafas.Core.newType("hafasEventSearch", {map: this.Controller.Map.instance});
  }

  /* HIM Instanz anlegen wenn Funktionalitaet eingeschaltet ist */
  if (Hafas.Config.Switches.useHimInterface) {
    this.himInterface = Hafas.Core.newType("hafasHimInterface", {
      version: Hafas.Config.HIM.version
    });
  }

  if (Hafas.Config.showCookieHint) {
    Hafas.ps.pub('/gui/showCookieHint');
  }

  if (Hafas.Core.getParameterByName("ctxRecon") != null) {
    var ctxRecon = Hafas.Core.getParameterByName("ctxRecon");
    this.Controller.TP.reconstructConnection = ctxRecon;
  }

  // Auf fullscreen events reagieren und publishen
  function triggerHafasFullscreenEvent(event) {
    Hafas.ps.pub('/GUI/fullscreen/changed', [Hafas.Util.fullscreen.isActive(), event]);
  }

  document.addEventListener('fullscreenchange', triggerHafasFullscreenEvent);
  document.addEventListener('webkitfullscreenchange', triggerHafasFullscreenEvent);
  document.addEventListener('mozfullscreenchange', triggerHafasFullscreenEvent);
  document.addEventListener('MSFullscreenChange', triggerHafasFullscreenEvent);

  var components = Hafas.Modules.Components;
  var webappContainer = Hafas('#HFS_WebApp');

  // register tooltips globally so they don't have to be created individually
  components.HafasTooltip.applyTo({
    containerClassName: 'lyr_tooltip',
    eventContainer: window,
    tooltipContainerParent: webappContainer
  });


  // create containers for accessible announcements (aria-live regions)
  Hafas.Modules.a11y.Announce.init(webappContainer);
  // Als Letztes den Loader ausblenden, wenn ein Splashscreen verwendet wurde
  if (typeof Hafas.Config.Switches.useSplashScreen != 'undefined' && Hafas.Config.Switches.useSplashScreen === true) {
    var $loader = Hafas('#HFS_Splashscreen', false);
    if ($loader) {
      $loader.addEventListener('transitionend', function () {
        Hafas.Util.gui.setVisibility($loader, false);
      });
      $loader.style.opacity = 0;
    }
  }
 Hafas.Modules.JumpIn.jumpInStartContext();

};
